export default String.raw`
{% include 'partials/companies/companies.html' with "manufactures" -%}
`